<template>
<div id="openingCover" class="fixed z-50 inset-0 bg-white transition-opacity duration-[2000ms] opacity-100">
  <div class="md:hidden w-screen overflow-hidden pt-28 mb-10">
    <img class="w-[calc(100vw+100px)] max-w-none -ml-12" :src="publickPath + '/images/bg-top@2x.png'">
  </div>
  <img class="hidden md:block xl:hidden lg:w-[calc(100vw-200px)] ml-auto mt-28" :src="publickPath + '/images/bg-top@2x.png'">
  <div class="hidden md:block container mx-auto pt-28">
      <div class="max-w-[1280px] mx-auto">
        <img class="hidden xl:block lg:w-[calc(100vw-200px)] xl:w-[1000px] h-auto ml-auto" :src="publickPath + '/images/bg-top@2x.png'">
      </div>
  </div>

</div>
<h6 class="fixed top-4 md:top-8 right-0 md:right-8 text-right futura md:text-xl tracking-wide z-40 mix-blend-multiply"> 
  <span class="inline-block bg-lemon-normal py-1 px-2">Here is a recruitment site</span><br>
  <span class="inline-block bg-lemon-normal py-1 px-2 mt-1">for Cento trenta</span>
</h6>

<div class="hidden md:block relative">
  <svg class="absolute -top-60 -left-72 mix-blend-multiply w-[546px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 546.62 420.22">
    <path fill="#e9d81c" d="M.59,76.12c1.11-9.75,4.48-39.5,27.43-58.81C47.85,.63,72.35,.08,80.64,0c57.89-.5,75.26,49.22,154.79,84.07,7.65,3.35,1.08,.09,86.59,23.9,113.3,31.55,134.35,39.94,157.97,56.58,27.38,19.28,58.63,41.3,65.43,77.58,5.65,30.11-10.74,42.34-8.82,96.66,1.21,34.26,8.15,41.14,1.08,53.96-14.9,27.02-65.34,32.04-102.77,23.93-41.38-8.96-50.8-30.49-98.02-56.05-47.05-25.47-73.54-23.51-114.38-35.86C95.9,286.48-8.81,158.97,.59,76.12Z"/>
  </svg>
</div>
<section class="relative" id="first">
  <a href="http://centotrenta.jp/" target="_blank" class="fixed left-0 top-4 md:top-10 py-2 pl-2 md:pl-8 inline-flex items-center z-10 border-b border-black font-bold text-xs md:text-sm">
    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
      <path fill="currentColor" d="M14,7L9,12L14,17V7Z" />
    </svg>
    本サイトに戻る
  </a>
  <div class="hidden md:block container mx-auto pt-28">
    <div class="max-w-[1280px] mx-auto">
      <div class="relative">
        <h3 class="absolute left-64 rotate-90 text-8xl han uppercase origin-top-left cormorant"><span class="text-9xl">L</span>et’s go</h3>
        <h3 class="absolute top-40 left-20 rotate-90 text-8xl han uppercase origin-top-left cormorant">with us</h3>
      </div>
      <img class="hidden xl:block lg:w-[calc(100vw-200px)] xl:w-[1000px] h-auto ml-auto" :src="publickPath + '/images/bg-top@2x.png'">
    </div>
  </div>
  <div class="md:hidden w-screen overflow-hidden pt-28 mb-10">
    <img class="w-[calc(100vw+100px)] max-w-none -ml-12" :src="publickPath + '/images/bg-top@2x.png'">
    <h3 class="pl-5 text-5xl han uppercase origin-top-left cormorant tracking-wider"><span class="text-7xl">L</span>et’s go</h3>
    <h3 class="pl-5 text-5xl han uppercase origin-top-left cormorant tracking-wider mt-3">with us</h3>
  </div>
  <img class="hidden md:block xl:hidden lg:w-[calc(100vw-200px)] ml-auto" :src="publickPath + '/images/bg-top@2x.png'">
</section>
<section>
  <div class="container mx-auto">
    <div class="max-w-[948px] mx-auto px-5 lg:px-0">
      <div class="hidden md:block relative mix-blend-multiply">
        <scroll-parallax :speed="0.15">
          <svg class="absolute -top-72 left-0 w-[546px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 546.62 420.22">
            <path fill="#e9d81c" d="M.59,76.12c1.11-9.75,4.48-39.5,27.43-58.81C47.85,.63,72.35,.08,80.64,0c57.89-.5,75.26,49.22,154.79,84.07,7.65,3.35,1.08,.09,86.59,23.9,113.3,31.55,134.35,39.94,157.97,56.58,27.38,19.28,58.63,41.3,65.43,77.58,5.65,30.11-10.74,42.34-8.82,96.66,1.21,34.26,8.15,41.14,1.08,53.96-14.9,27.02-65.34,32.04-102.77,23.93-41.38-8.96-50.8-30.49-98.02-56.05-47.05-25.47-73.54-23.51-114.38-35.86C95.9,286.48-8.81,158.97,.59,76.12Z"/>
          </svg>
        </scroll-parallax>
      </div>
      <div class="relative">
        <div class="md:hidden absolute mix-blend-multiply -left-20 -top-60 w-[350px]">
          <scroll-parallax :speed="0.15">
            <svg class="w-[350px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 516.6 472.66">
              <path fill="#e9d81c" d="M431.69,45.27h0s55.63,30.32,75.7,71.27c17.9,36.53,5.28,76.98-.95,96.96-19.11,61.23-53.57,58.29-80.55,122.62-22.41,53.41-7.25,75.92-34.82,103.97-24.99,25.43-59.18,29.04-82.59,31.51-87.03,9.19-154.4-43.95-159.38-48-36.21-29.44-31.62-46.53-75.06-75.96-38.09-25.81-54.49-21.39-66.29-41.5-20.46-34.84,2.81-92.32,32.11-127.51,35.81-43,61.33-29.55,118.01-77.29C212.19,55.58,207.85,27.13,245.19,7.58c30.34-15.89,96.27-8.38,186.51,37.69Z"/>
            </svg>
          </scroll-parallax>
        </div>
      </div>
      <p id="conceptText" class="text-[13px] md:text-base leading-8 md:leading-10 han fadeinupeffect">
        現在、私共アパレル業界も試練の時を迎えております。<br>
        テクノロジーの進歩は目覚ましく、それに伴い社会のシステムが急速に変化し、<br class="hidden md:block">
        取分け私共の業界においては、変化の速度が速い分、ちょっとした出足の遅れが、<br class="hidden md:block">
        結果的に大きな差を生む可能性も十分に考えられます。<br>
        しかし、こんなご時世だからこそ気づけた事がたくさんあります。<br>
        衣食住の“衣”はどんな時であっても、“ヒト”にワクワクを与えてくれ、<br class="hidden md:block">
        “服”を通じて世の中の人々に“福”をもたらす、そんな仕事に就いていると自負しております。<br>
        私共が考える「服を通じてイキる」これは格好をつける事ではありません。
      </p>

      <div class="md:flex items-center mt-14">
        <div class=" w-[132px]">
          <h3 class="han font-bold  text-xl whitespace-nowrap inline-block swingineffect scrolleffect" >
            <div class="bg-lemon-normal px-4 py-1 inline-block">
              イキるとは
            </div>
          </h3>
        </div>
        <h6 class="han font-bold text-xl md:ml-4 mt-6 md:mt-0">
          「粋る」「生きる」「活きる」
        </h6>
      </div>
      <p class="text-[13px] md:text-base leading-8 md:leading-10 han mt-6 scrolleffect fadeinupeffect">
        我々は「Gentleman’s Agreement（ジェントルマンズ・アグリーメント／紳士協定）」の名のもとに集まった“イキる”集団です。<br class="hidden md:block">
        ここに全てが集約されています。<br>
        <br class="hidden md:block">
        近い将来セレクトショップという形態が淘汰され、新しい“形”が生まれてくると私自身は考えております。<br class="hidden md:block">
        そこで私共が目指すのは、お客さまの「ライフスタイル」に関わり、<br class="hidden md:block">
        ライフスタイルをコーディネイトする新しい形となるネクストセレクトショップを創りだしていきたいと考えております。<br>
        <br class="hidden md:block">
        “者（ヒト）”が“物（商品）”を売り“モノ（価値）”となる<br class="hidden md:block">
        社会に貢献できる価値に転換できるのは、社会を形成し社会に責任を持つ“人“でしかなしえません。<br class="hidden md:block">
        そう、どのような業界であれ、人で成り立っているわけですから。<br>
        仕事とは本来ワクワクするもの。そんなワクワクを一緒に感じながら共に“イキり”ましょう。
      </p>
    </div>
  </div>
</section>
<section class="-mt-8 md:pt-20 relative">
  <div class="relative">
    <div class="w-screen overflow-hidden">
      <div class="flex w-[3746px] anim-whats-pc">
        <h2 class="cormorant text-[140px] uppercase tracking-wider whitespace-nowrap px-8"><span class="text-[200px]">W</span>hat’s <span class="text-[200px]">C</span>ento trenta</h2>
        <h2 class="cormorant text-[140px] uppercase tracking-wider whitespace-nowrap px-8"><span class="text-[200px]">W</span>hat’s <span class="text-[200px]">C</span>ento trenta</h2>
      </div>
    </div>
    <div class="hidden md:block absolute mix-blend-multiply right-0 -top-60 w-[400px]">
      <scroll-parallax :speed="0.15">
        <svg class="w-[400px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 472.66">
          <path fill="#e9d81c" d="M431.69,45.27h0s55.63,30.32,75.7,71.27c17.9,36.53,5.28,76.98-.95,96.96-19.11,61.23-53.57,58.29-80.55,122.62-22.41,53.41-7.25,75.92-34.82,103.97-24.99,25.43-59.18,29.04-82.59,31.51-87.03,9.19-154.4-43.95-159.38-48-36.21-29.44-31.62-46.53-75.06-75.96-38.09-25.81-54.49-21.39-66.29-41.5-20.46-34.84,2.81-92.32,32.11-127.51,35.81-43,61.33-29.55,118.01-77.29C212.19,55.58,207.85,27.13,245.19,7.58c30.34-15.89,96.27-8.38,186.51,37.69Z"/>
        </svg>
      </scroll-parallax>
    </div>

  </div>
  <div class="container mx-auto md:pt-20 md:pb-20">
    <img class="hidden md:block absolute bottom-10 right-10 w-[465px] mix-blend-multiply" :src="publickPath + '/images/whats.png'">
    <div class="max-w-[948px] mx-auto px-5 lg:px-0">
      <h3 class="font-bold han text-2xl tracking-wider md:mt-10">Gentleman’s Agreement／紳士協定</h3>
      <div class="inline-block my-8 whitespace-nowrap swingineffect scrolleffect">
        <h4 class=" han font-bold bg-lemon-normal px-4 py-1 text-xl">
          イキる集団
        </h4>
      </div>
      <p class="text-sm han scrolleffect fadeinupeffect">ジェントルマンズ・アグリーメントを体現することにより、お客様と共に、服を通じて社会に福を生み出す集団である。</p>
      <h6 class="inline-block mt-10 han font-bold text-xl scrolleffect fadeinupeffect">
        「粋る」
      </h6>
      <p class="han text-sm mt-4 scrolleffect fadeinupeffect">
        「粋る」とは、装い、気遣い、言動すなわち所作をナチュラルにこなせる人間である。<br>我々ライフスタイリストは、紳士育成集団である。
      </p>
      <h6 class="inline-block mt-10 han font-bold text-xl scrolleffect fadeinupeffect">
        「生きる」
      </h6>
      <p class="han text-sm mt-4 scrolleffect fadeinupeffect">
        「生きる」とは、気高く生きることである。<br>我々ライフスタイリストは、生きることに力を与える存在である。
      </p>
      <h6 class="inline-block mt-10 han font-bold text-xl scrolleffect fadeinupeffect">
        「活きる」
      </h6>
      <p class="han text-sm mt-4 scrolleffect fadeinupeffect">
        「活きる」とは、あらゆる困難の中でも活路を見出し、自分らしく活躍することである。<br>我々ライフスタイリストは、トレンド創生の集団である。
      </p>
    </div>
  </div>
  <img class="md:hidden w-screen h-96 object-cover mt-6 mb-10" :src="publickPath + '/images/whats.png'">
</section>

<section class="bg-[#f8f8f8] relative">
  <div class="hidden md:block absolute right-0 top-[500px] mix-blend-multiply z-10">
    <scroll-parallax :speed="0.15">
      <svg class="w-[400px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 469.24">
          <path fill="#e9d81c" d="M1.7,235.59C-1.2,194.54-8.77,87.25,65.5,31.43c3.77-2.83,54.17-39.55,116.97-29.77,37.52,5.84,49.85,23.67,127.6,82.94,99.01,75.47,109.13,69.51,119.1,93.58,30.22,72.99-41.39,179.68-116.97,233.94-26.7,19.17-109.72,78.76-191.4,48.91C14.88,422.32,3.92,267.12,1.7,235.59Z"/>
      </svg>
    </scroll-parallax>
  </div>
  <div class="container mx-auto py-20">
    <div class="max-w-[910px] mx-auto px-5 lg:px-0">
      <div class="relative">
        <h2 class="han font-bold text-2xl md:text-3xl tracking-widest flex items-end"><span class="cormorant text-8xl md:text-9xl font-normal">4</span><span class="text-lg md:text-xl">つの</span>事業</h2>
        <h6 class="cormorant text-5xl md:text-6xl tracking-wider uppercase mt-4"><span class="text-7xl md:text-8xl">P</span>roject</h6>
        <div class="absolute mix-blend-multiply -left-60 md:-left-28 -top-[500px] w-[550px] z-10">
          <scroll-parallax :speed="0.15">
            <svg class="w-[550px]"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 550.45 325.85">
              <path fill="#e9d81c" d="M526.02,39.91c6.02,6.34,24.4,25.68,24.43,52.42,.03,23.09-13.63,40.14-18.33,45.84-32.82,39.8-76.71,23.18-146.07,57.51-6.67,3.3-.68,.69-65.92,45.42-86.44,59.27-104.23,68.84-129.12,75.43-28.85,7.65-61.78,16.37-90.45,.23-23.79-13.4-22.75-31.59-60.93-61.4-24.08-18.8-32.75-18-37.45-30.17-9.91-25.65,15.56-62.96,42.53-83.87,29.82-23.11,49.91-17.21,94.42-34.81,44.34-17.53,58.17-36.74,90.01-57.54,98.67-64.49,245.7-62.93,296.88-9.05Z"/>
            </svg>
          </scroll-parallax>
        </div>
      </div>
      <ProjectPc v-if="!isMobilePhone"/>
      <ProjectMobile v-else/>
    </div>
  </div>
</section>

<section class="py-20 relative w-screen overflow-hidden">
  <div class="hidden md:block absolute -z-10 top-0 -left-10 ">
    <scroll-parallax :speed="0.15">
      <svg class="w-[510px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 516.6 472.66">
        <path fill="#e9d81c" d="M431.69,45.27h0s55.63,30.32,75.7,71.27c17.9,36.53,5.28,76.98-.95,96.96-19.11,61.23-53.57,58.29-80.55,122.62-22.41,53.41-7.25,75.92-34.82,103.97-24.99,25.43-59.18,29.04-82.59,31.51-87.03,9.19-154.4-43.95-159.38-48-36.21-29.44-31.62-46.53-75.06-75.96-38.09-25.81-54.49-21.39-66.29-41.5-20.46-34.84,2.81-92.32,32.11-127.51,35.81-43,61.33-29.55,118.01-77.29C212.19,55.58,207.85,27.13,245.19,7.58c30.34-15.89,96.27-8.38,186.51,37.69Z"/>
      </svg>
    </scroll-parallax>
  </div>
  <div class="container mx-auto">
    <div class="max-w-[900px] mx-auto px-5 lg:px-0">
      <h3 class="font-bold text-2xl md:text-3xl han">チェントトレンタで働く人</h3>
      <h5 class="cormorant text-5xl tracking-wider"><span class="text-7xl">S</span>TAFF</h5>
      <StaffPc v-if="!isMobilePhone" />
      <StaffMobile v-else />
    </div>
  </div>
</section>

<div class="container mx-auto mt-10 px-5 lg:px-0">
  <div class="flex justify-center">
    <svg width="40" height="73" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.23 73.45">
      <line fill="none" stroke="#000" stroke-width="1.5" x1="16.51" y1=".23" x2="39.51" y2="73.23"/>
      <line fill="none" stroke="#000" stroke-width="1.5" x1=".51" y1="51.23" x2="16.51" y2="66.23"/>
    </svg>
    <div class="cormorant uppercase text-center text-2xl md:text-4xl tracking-wider mx-4 md:mx-10 relative">
      <svg class="absolute -z-10 -top-10 left-[calc(50%-80px)] md:left-[calc(50%-100px)] w-40 md:w-[200px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 516.6 472.66">
        <path fill="#e9d81c" d="M431.69,45.27h0s55.63,30.32,75.7,71.27c17.9,36.53,5.28,76.98-.95,96.96-19.11,61.23-53.57,58.29-80.55,122.62-22.41,53.41-7.25,75.92-34.82,103.97-24.99,25.43-59.18,29.04-82.59,31.51-87.03,9.19-154.4-43.95-159.38-48-36.21-29.44-31.62-46.53-75.06-75.96-38.09-25.81-54.49-21.39-66.29-41.5-20.46-34.84,2.81-92.32,32.11-127.51,35.81-43,61.33-29.55,118.01-77.29C212.19,55.58,207.85,27.13,245.19,7.58c30.34-15.89,96.27-8.38,186.51,37.69Z"/>
      </svg>
      welcome to<br>
      cento trenta
    </div>
    <svg class=" -scale-x-100" width="40" height="73" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.23 73.45">
      <line fill="none" stroke="#000" stroke-width="1.5" x1="16.51" y1=".23" x2="39.51" y2="73.23"/>
      <line fill="none" stroke="#000" stroke-width="1.5" x1=".51" y1="51.23" x2="16.51" y2="66.23"/>
    </svg>

  </div>
  <hr class="max-w-[1150px] mx-auto border-2 border-black mt-40">
</div>

<section id="requirements">
  <div class="container mx-auto">
    <div class="max-w-[940px] mx-auto pb-20 px-5 lg:px-0">
      <h2 class="han text-xl md:text-4xl mt-20">募集要項一覧</h2>
      <hr class=" w-8 mr-auto border border-black mt-6">
      <div class="mt-8 md:grid grid-cols-5 gap-10">
        <div class="hidden md:block col-span-2 scrolleffect fadeinupeffect">
          <img class="w-full h-auto" :src="publickPath+'/images/staff-4.jpg'">
        </div>
        <div class="col-span-3 scrolleffect fadeinupeffect">
          <h5 class="text-2xl han lg:whitespace-nowrap">1. リテールセールス職（新卒採用／キャリア採用）</h5>
          <img class="md:hidden mt-6 w-full h-auto" :src="publickPath+'/images/staff-4.jpg'">
          <ul class=" list-disc pl-6 mt-6">
            <li class="mb-6">
              <span class="font-bold text-sm">リテールセールス エキスパート（ストア マネジャー候補）</span>
              <div class="text-xs mt-1">→ 正社員 / 契約社員</div>
            </li>
            <li class="mb-6">
              <span class="font-bold text-sm">セールス アソシエイト（販売サポートスタッフ）</span>
              <div class="text-xs mt-1">→ アルバイト</div>
            </li>
          </ul>
          <p class="text-xs leading-6">
            店舗へご来店されたお客様に、ご満足いただけるコーディネートを提案することが主な業務です。 具体的には、接客・販売、商品管理などのバックヤード業務など、店舗運営業務全般に必要なスキルを身につけていただき、将来的にストアマネジメントを行っていただきます。能力に応じバイイング業務などを経てMD職へのキャリアアップもございます。
          </p>
        </div>

        <div class="hidden md:block col-span-2 scrolleffect fadeinupeffect">
          <img class="w-full h-auto" :src="publickPath+'/images/staff-5.jpg'">
        </div>
        <div class="col-span-3 mt-10 md:mt-0 scrolleffect fadeinupeffect">
          <h5 class="text-2xl han lg:whitespace-nowrap">2. デジタルキャリア職（キャリア採用）</h5>
          <img class="md:hidden mt-6 w-full h-auto" :src="publickPath+'/images/staff-5.jpg'">
          <ul class=" list-disc pl-6 mt-6">
            <li class="mb-6">
              <span class="font-bold text-sm">デジタルエキスパート（WEBスタッフ）</span>
              <div class="text-xs mt-1">→ 正社員 / 契約社員</div>
            </li>
            <li class="mb-6">
              <span class="font-bold text-sm">デジタルアソシエイト（WEBサポートスタッフ）</span>
              <div class="text-xs mt-1">→ アルバイト</div>
            </li>
          </ul>
          <p class="text-xs leading-6">
            オンラインサイトの運営、SNSなどの電子メディアを通じたデジタルマーケティングが主な業務。商品の在庫管理、商品データ登録、画像撮影及びその関連業務や、 電子メディアを通じた、商品やブランド、サービスのマーケティング、またはそれらのアシスタント業務となります。
          </p>
        </div>

        <div class="hidden md:block col-span-2 scrolleffect fadeinupeffect">
          <img class="w-full h-auto" :src="publickPath+'/images/staff-6.jpg'">
        </div>
        <div class="col-span-3 mt-10 md:mt-0 scrolleffect fadeinupeffect">
          <h5 class="text-2xl han lg:whitespace-nowrap">3. コーポレート職（キャリア採用）</h5>
          <img class="md:hidden mt-6 w-full h-auto" :src="publickPath+'/images/staff-6.jpg'">
          <ul class=" list-disc pl-6 mt-3">
            <li class="mb-3">
              <span class="font-bold text-sm">ホールセールスエキスパート（卸営業）</span>
              <div class="text-xs mt-1">→ 正社員 / 契約社員</div>
            </li>
            <li class="mb-3">
              <span class="font-bold text-sm">トータル エキスパート（総合職）</span>
              <div class="text-xs mt-1">→ 正社員 / 契約社員</div>
            </li>
            <li class="mb-3">
              <span class="font-bold text-sm">バックヤード アソシエイト（事務サポートスタッフ）</span>
              <div class="text-xs mt-1">→ アルバイト</div>
            </li>
          </ul>
          <p class="text-xs leading-6">
            経営企画、営業、カンパニーブランディングやPR、販売促進やプレス、財務や人事、事業マネジメントなどに関わる本部職種となり、またはそれらのサポートやバックヤードの総合的事務アシスタント業務となります。
          </p>
        </div>
      </div>

      <h2 class="han text-xl md:text-4xl mt-20">採用情報</h2>

      <hr class=" w-8 mr-auto border border-black mt-6">

      <h3 class="mt-10"><span class="inline-block border-2 border-black px-4 py-2 text-2xl font-bold">リテールセールス職</span></h3>
      <ul class="mt-6 font-bold text-lg">
        <li>リテールセールスエキスパート／アソシエイト</li>
        <li>新卒採用／キャリア採用</li>
      </ul>
      <h6 class="mt-6"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">給与</span></h6>
      <div class="md:grid grid-cols-2">
        <div>
          <h5 class="font-bold text-xl mt-4">正社員 / 契約社員 月給 210,000 円~250,000円</h5>
          <ul class="mt-6 leading-8">
            <li>実務経験・能力を考慮し、当社規定にて決定します。</li>
            <li>実績に応じて賞与あり</li>
            <li>※3か月間の試用期間あり（期間中の変動なし）</li>
            <li>※試用期間経過後、当社規定にて給与の見直しあり</li>
          </ul>
        </div>
        <div class="md:pl-10 md:border-l-2 border-black">
          <h5 class="font-bold text-xl mt-4">アルバイト 時給 1,100 円~1,500円</h5>
          <ul class="mt-6 leading-8">
            <li>経験・能力を考慮し、当社規定にて決定します。</li>
            <li>残業代全額支給</li>
          </ul>
        </div>
      </div><!-- /.grid -->

      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">休日・休暇等</span></h6>
      <div class="md:grid grid-cols-2">
        <div>
          <h5 class="font-bold text-xl mt-4">正社員 / 契約社員</h5>
          <ul class="mt-6 leading-8 list-disc pl-4">
            <li>月6日以上のシフト制 実働7h / 休憩1h</li>
            <li>夏季・冬期休暇（各4日）・有給休暇・慶弔休暇<br>その他特別休暇あり</li>
          </ul>
        </div>
        <div class="md:pl-10 md:border-l-2 border-black">
          <h5 class="font-bold text-xl mt-4">アルバイト</h5>
          <ul class="mt-6 leading-8 list-disc pl-4">
            <li>シフト制 週3日以上、1日5h以上</li>
          </ul>
        </div>
      </div><!-- /.grid -->

      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">諸手当</span></h6>
      <p class="mt-4">
        交通費支給（正社員 / 契約社員 上限 月額30,000円 ・ アルバイト 日額 1,000円 迄）当社規定による））、従業員割引制度、社員登用制度
      </p>
      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">勤務地</span></h6>
      <ul class="mt-4 leading-8 list-disc pl-4">
        <li>大阪（南船場店（中央区南船場）、阪急メンズ大阪店（北区角田町）、三休橋店（中央区備後町）、D-TE SHOE STORE（中央区南船場））</li>
      </ul>
      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">必須スキル／条件</span></h6>
      <p class="mt-4 leading-7">
        ジェントルマンズ・アグリーメントに共感し、体現したいと思っている人。<br>
        各種OFFICE製品の基本操作 
      </p>
      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">求める人物像／歓迎スキル</span></h6>
      <p class="mt-4 leading-7">
        自らが、自らの理想を体現できる、またはそうありたいと願い叶えたいと思っている人。 お客様がより良く「粋る／生きる／活きる」ためのパートナーとして、あり続けられる人。 順応した意見ではなく、自らの個性を活かした提案や意見ができる人。
      </p>

      <hr class="mt-12 border-gray-300">

      <h3 class="mt-12"><span class="inline-block border-2 border-black px-4 py-2 text-2xl font-bold">デジタルキャリア職</span></h3>
      <ul class="mt-6 font-bold text-lg">
        <li>デジタルエキスパート／アソシエイト</li>
        <li>キャリア採用</li>
      </ul>
      <h6 class="mt-6"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">給与</span></h6>
      <div class="md:grid grid-cols-2">
        <div>
          <h5 class="font-bold text-xl mt-4">正社員 / 契約社員 月給 210,000 円~</h5>
          <ul class="mt-6 leading-8">
            <li>実務経験・能力を考慮し、当社規定にて決定します。</li>
            <li>実績に応じて賞与あり</li>
            <li>※3か月間の試用期間あり（期間中の変動なし）</li>
            <li>※試用期間経過後、当社規定にて給与の見直しあり</li>
          </ul>
        </div>
        <div class="md:pl-10 md:border-l-2 border-black">
          <h5 class="font-bold text-xl mt-4">アルバイト 時給 1,100 円~</h5>
          <ul class="mt-6 leading-8">
            <li>経験・能力を考慮し、当社規定にて決定します。</li>
            <li>残業代全額支給</li>
          </ul>
        </div>
      </div><!-- /.grid -->

      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">休日・休暇等</span></h6>
      <div class="md:grid grid-cols-2">
        <div>
          <h5 class="font-bold text-xl mt-4">正社員 / 契約社員</h5>
          <ul class="mt-6 leading-8 list-disc pl-4">
            <li>日祝、隔週土曜日 実働7h / 休憩1h</li>
            <li>夏季・冬期休暇（各4日）・有給休暇・慶弔休暇<br>その他特別休暇あり</li>
          </ul>
        </div>
        <div class="md:pl-10 md:border-l-2 border-black">
          <h5 class="font-bold text-xl mt-4">アルバイト</h5>
          <ul class="mt-6 leading-8 list-disc pl-4">
            <li>シフト制 週3日以上、1日5h以上</li>
          </ul>
        </div>
      </div><!-- /.grid -->

      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">諸手当</span></h6>
      <p class="mt-4">
        交通費支給（正社員 / 契約社員 上限 月額30,000円 ・ アルバイト 日額 1,000円 迄）当社規定による））、従業員割引制度、社員登用制度
      </p>
      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">勤務地</span></h6>
      <ul class="mt-4 leading-8 list-disc pl-4">
        <li>本社（中央区南船場）</li>
      </ul>
      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">必須スキル／条件</span></h6>
      <p class="mt-4 leading-7">
        ジェントルマンズ・アグリーメントに共感し、体現したいと思っている人。<br>
        Photoshop、Illustrator、各種OFFICE製品の基本操作
      </p>
      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">求める人物像／歓迎スキル</span></h6>
      <p class="mt-4 leading-7">
        自らが、自らの理想を体現できる、またはそうありたいと願い叶えたいと思っている人。<br>
        WEBディレクションなどの経験<br>
        HTML、CSSの基礎知識 DreamWeaver、Adobe XDなどの基本操作<br>
        WordPressなどのCMS運用経験
      </p>

            <hr class="mt-12 border-gray-300">

      <h3 class="mt-12"><span class="inline-block border-2 border-black px-4 py-2 text-2xl font-bold">コーポレート職</span></h3>
      <ul class="mt-6 font-bold text-lg">
        <li>ホールセールスエキスパート／トータル エキスパート／バックヤードアソシエイト</li>
        <li>キャリア採用</li>
      </ul>
      <h6 class="mt-6"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">給与</span></h6>
      <div class="md:grid grid-cols-2">
        <div>
          <h5 class="font-bold text-xl mt-4">正社員 / 契約社員 月給 200,000 円~</h5>
          <ul class="mt-6 leading-8">
            <li>実務経験・能力を考慮し、当社規定にて決定します。</li>
            <li>実績に応じて賞与あり</li>
            <li>※3か月間の試用期間あり（期間中の変動なし）</li>
            <li>※試用期間経過後、当社規定にて給与の見直しあり</li>
          </ul>
        </div>
        <div class="md:pl-10 md:border-l-2 border-black">
          <h5 class="font-bold text-xl mt-4">アルバイト 時給 1,100円~1,500円</h5>
          <ul class="mt-6 leading-8">
            <li>経験・能力を考慮し、当社規定にて決定します。</li>
            <li>残業代全額支給</li>
          </ul>
        </div>
      </div><!-- /.grid -->

      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">休日・休暇等</span></h6>
      <div class="md:grid grid-cols-2">
        <div>
          <h5 class="font-bold text-xl mt-4">正社員 / 契約社員</h5>
          <ul class="mt-6 leading-8 list-disc pl-4">
            <li>日祝、隔週土曜日 実働7h / 休憩1h</li>
            <li>夏季・冬期休暇（各4日）・有給休暇・慶弔休暇<br>その他特別休暇あり</li>
          </ul>
        </div>
        <div class="md:pl-10 md:border-l-2 border-black">
          <h5 class="font-bold text-xl mt-4">アルバイト</h5>
          <ul class="mt-6 leading-8 list-disc pl-4">
            <li>シフト制 週3日以上、1日5h以上</li>
          </ul>
        </div>
      </div><!-- /.grid -->

      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">諸手当</span></h6>
      <p class="mt-4">
        交通費支給（正社員 / 契約社員 上限 月額30,000円 ・ アルバイト 日額 1,000円 迄）当社規定による））、従業員割引制度、社員登用制度
      </p>
      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">勤務地</span></h6>
      <ul class="mt-4 leading-8 list-disc pl-4">
        <li>本社（中央区南船場）</li>
      </ul>
      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">必須スキル／条件</span></h6>
      <p class="mt-4 leading-7">
        ジェントルマンズ・アグリーメントに共感し、体現したいと思っている人。<br>
        各種OFFICE製品の基本操作
      </p>
      <h6 class="mt-8"><span class="han font-bold text-white inline-block bg-black py-1 tracking-wider px-4">求める人物像／歓迎スキル</span></h6>
      <p class="mt-4 leading-7">
        自らが、自らの理想を体現できる、またはそうありたいと願い叶えたいと思っている人。
      </p>
    </div><!-- /.max-w-[940px] -->
  </div>
</section>
<section class="bg-[#f8f8f8]">
  <div class="container mx-auto">
    <div class="max-w-[940px] mx-auto pt-20 pb-40 px-5 lg:px-0">
      <h2 class="han text-2xl md:text-4xl">応募について</h2>
      <hr class=" w-8 mr-auto border border-black mt-6">
      <h6 class="font-bold text-sm han mt-10">選考の流れ</h6>
      <div class="lg:flex items-center mt-4">
        <div class="text-lg bg-black text-white han text-center flex-1 py-2">
          応募フォーム入力<small class="text-sm">（書類提出）</small>
        </div>
        <svg class="w-6 h-6 mx-auto lg:mx-4 rotate-90 lg:rotate-0 my-4 lg:my-0"  viewBox="0 0 24 24">
          <path fill="currentColor" d="M14 16.94V12.94H5.08L5.05 10.93H14V6.94L19 11.94Z" />
        </svg>
        <div class="text-lg bg-black text-white han text-center flex-1 py-2">
          面接<small class="text-sm">（1~2回）</small>
        </div>
        <svg class="w-6 h-6 mx-auto lg:mx-4 rotate-90 lg:rotate-0 my-4 lg:my-0"  viewBox="0 0 24 24">
          <path fill="currentColor" d="M14 16.94V12.94H5.08L5.05 10.93H14V6.94L19 11.94Z" />
        </svg>
        <div class="text-lg bg-black text-white han text-center flex-1 py-2">
          採用 / 内定
        </div>
      </div>
      <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSeTOrYjlFQMeUi2pu_9X2enLOFKaWkhSx4VS7AR8blXUU_m1w/viewform?usp=sf_link" class="bg-white mt-10 block w-full border-2 border-black transition-colors hover:bg-gray-100 text-center py-2 han text-lg">
        応募する
      </a>
    </div><!-- /.max-w-[940px] -->
  </div>
</section>
<FixedController />
</template>

<script setup>
import { onMounted } from 'vue';
import { computed } from '@vue/reactivity';
import FixedController from './components/FixedController.vue'
import ScrollParallax from 'vue3-parallax/src/components/ScrollParallax.vue';
import { isMobile } from 'mobile-device-detect';
import ProjectPc from './components/Project/ProjectPc.vue'
import ProjectMobile from './components/Project/AMobile.vue'
import StaffPc from './components/Staff/StaffPc.vue'
import StaffMobile from './components/Staff/AMobile.vue'
import { $ } from 'dom7';
/* eslint-disable */
onMounted(() => {
  $(window).on('scroll', function(){
    // console.log('scroll', jQuery(window).scrollTop())
    let scroll = jQuery(window).scrollTop()
    let windowH = jQuery(this).height();

    jQuery('.scrolleffect').each(function(i, e){
			if (!jQuery(this).hasClass('showing')) {
				var imgPos = jQuery(this).offset().top;
				// var imgHeight = $(this).height();
				if (scroll > imgPos - windowH){
					jQuery(this).addClass('showing')
				}
			}
		});
  })
  setTimeout(() => {
    $('#openingCover').addClass('!opacity-0 absolute pointer-events-none').removeClass('fixed')
    $('body').removeClass('overflow-hidden')
  }, 1600)
  setTimeout(() => {
    $('#conceptText').addClass('showing')
  }, 2200)
  setTimeout(() => {
    $('#openingCover').remove()
  }, 4000)

})

const isMobilePhone = computed(() => {
  return isMobile
})
const publickPath = computed(() => {
  if (process.env.NODE_ENV === 'production') {
    return '/recruit'
  } else {
    return ''
  }
})
</script>

<style>
body {
  overflow-x: hidden;
  overflow-y: scroll;
}
@keyframes whatspc {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-1873px, 0);
  }
  
}
.anim-whats-pc {
  animation: whatspc 20s linear infinite;
}

.swingineffect {
  overflow: hidden;
  max-width: 0;
  transition: max-width 0.7s;
  position: relative;
}
.swingineffect.showing {
  max-width: 100%;
}
.swingineffect:after {
  display: block;
  content: '';
  background-color: #e9d81c;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: width 0.7s;
  transition-delay: 0.35s;
}
.swingineffect.showing:after {
  width: 0%;
  background-color: #e9d81c;
}
.fadeinupeffect {
  transform: translate(0, 100px);
  opacity: 0;
  transition-property: transform opacity;
  transition-duration: 0.6s;
}
.fadeinupeffect.showing {
  transform: translate(0, 0);
  opacity: 1;  
}
</style>